import { Injectable } from '@angular/core';
import {AbstractDatabaseService} from "../../tandem-core/services/abstract-database.service";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {CashFlowChartMetadata} from "../models/cash-flow-chart-metadata";
import {Timestamp} from "firebase/firestore";

@Injectable({
  providedIn: 'root'
})
export class CashFlowChartMetadataService extends AbstractDatabaseService<CashFlowChartMetadata> {

  constructor(protected override afs: AngularFirestore) {
    super('cashFlowChartMetadata', afs);
  }

  generateSampleChartData(userId: string): CashFlowChartMetadata {

    return {
      userId: "",
      charts: [
        {
          totalBusinessExpenses: 4615.26,
          totalLifestyleExpenses: 2159.4300000000003,
          totalPYFExpenses: 3711.13,
          totalEssentialExpenses: 4974.93,
          cashFlowId: 'OnFe38aa8JoUOofmYNAF',
          netCashFlow: 6265.800000000003,
          startDate: Timestamp.fromDate(new Date("2025-05-01")),
          endDate: Timestamp.fromDate(new Date("2025-05-31")),
          totalRevenue: 21726.55
        },
        {
          totalBusinessExpenses: 18588.88,
          totalRevenue: 15233.4,
          netCashFlow: -9858.090000000013,
          totalLifestyleExpenses: 606.45,
          startDate: Timestamp.fromDate(new Date("2025-06-01")),
          endDate: Timestamp.fromDate(new Date("2025-06-30")),
          totalPYFExpenses: 1250,
          cashFlowId: 'kAthcwjejCZqBMgGimFm',
          totalEssentialExpenses: 4646.160000000001
        },
        {
          totalEssentialExpenses: 5189.37,
          totalBusinessExpenses: 8188.34,
          totalRevenue: 45072.29,
          startDate: Timestamp.fromDate(new Date("2025-07-01")),
          endDate: Timestamp.fromDate(new Date("2025-07-31")),
          totalPYFExpenses: 4938.4,
          cashFlowId: '1ZNPzi4XL7Tm3T74UPMb',
          netCashFlow: 21052.28,
          totalLifestyleExpenses: 5703.9
        },
        {
          startDate: Timestamp.fromDate(new Date("2025-08-01")),
          endDate: Timestamp.fromDate(new Date("2025-08-31")),
          netCashFlow: 43414.78999999999,
          totalPYFExpenses: 8794.43,
          totalBusinessExpenses: 8169.110000000001,
          totalLifestyleExpenses: 4728.13,
          totalEssentialExpenses: 6506.93,
          cashFlowId: 'us0U2IKNMlw3Dsh1z8GY',
          totalRevenue: 71613.39
        },
        {
          cashFlowId: 'kMD2PImhRwGorG4jWIGi',
          startDate: Timestamp.fromDate(new Date("2025-05-01")),
          endDate: Timestamp.fromDate(new Date("2025-05-31")),
          netCashFlow: 7755.65,
          totalRevenue: 10000,
          totalPYFExpenses: 250,
          totalBusinessExpenses: 100,
          totalEssentialExpenses: 1874.35,
          totalLifestyleExpenses: 20
        }
      ],
      dateModified: Timestamp.now(),
      dateCreated: Timestamp.now()
    }
    // let dates: Date[] = [];
    // let currentDate = new Date();
    //
    // for (let i = 0; i < 7; i++) {
    //   // Add a copy of the current date to the array
    //   dates.push(new Date(currentDate.getTime()));
    //
    //   // Subtract one month from the current date
    //   currentDate.setMonth(currentDate.getMonth() - 1);
    // }
    // return {
    //   userId: userId,
    //   dateCreated: Timestamp.now(),
    //   dateModified: Timestamp.now(),
    //   charts: [
    //     {
    //       cashFlowId: '1',
    //       startDate: Timestamp.fromDate(dates[6]),
    //       endDate: Timestamp.fromDate(dates[5]),
    //       totalRevenue: 6784.15,
    //       totalPYFExpenses: 847.62,
    //       totalEssentialExpenses: 3217.62,
    //       totalLifestyleExpenses: 1806.74,
    //       netCashFlow: 912.17,
    //       totalBusinessExpenses: null,
    //     },
    //     {
    //       cashFlowId: '2',
    //       startDate: Timestamp.fromDate(dates[5]),
    //       endDate: Timestamp.fromDate(dates[4]),
    //       totalRevenue: 7152.48,
    //       totalPYFExpenses: 912.74,
    //       totalEssentialExpenses: 3174.98,
    //       totalLifestyleExpenses: 2284.36,
    //       netCashFlow: 780.40,
    //       totalBusinessExpenses: null,
    //     },
    //     {
    //       cashFlowId: '3',
    //       startDate: Timestamp.fromDate(dates[4]),
    //       endDate: Timestamp.fromDate(dates[3]),
    //       totalRevenue: 8574.38,
    //       totalPYFExpenses: 1736.84,
    //       totalEssentialExpenses: 3481.84,
    //       totalLifestyleExpenses: 746.85,
    //       netCashFlow: 2608.85,
    //       totalBusinessExpenses: null,
    //     },
    //     {
    //       cashFlowId: '4',
    //       startDate: Timestamp.fromDate(dates[3]),
    //       endDate: Timestamp.fromDate(dates[2]),
    //       totalRevenue: 7184.02,
    //       totalPYFExpenses: 1235.07,
    //       totalEssentialExpenses: 3084.25,
    //       totalLifestyleExpenses: 2974.05,
    //       netCashFlow: -109.35,
    //       totalBusinessExpenses: null,
    //     },
    //     {
    //       cashFlowId: '5',
    //       startDate: Timestamp.fromDate(dates[2]),
    //       endDate: Timestamp.fromDate(dates[1]),
    //       totalRevenue: 5864.15,
    //       totalPYFExpenses: 473.15,
    //       totalEssentialExpenses: 3368.51,
    //       totalLifestyleExpenses: 1058.67,
    //       netCashFlow: 963.82,
    //       totalBusinessExpenses: null,
    //     },
    //     {
    //       cashFlowId: '6',
    //       startDate: Timestamp.fromDate(dates[1]),
    //       endDate: Timestamp.fromDate(dates[0]),
    //       totalRevenue: 9748.35,
    //       totalPYFExpenses: 2674.05,
    //       totalEssentialExpenses: 3287.49,
    //       totalLifestyleExpenses: 2874.94,
    //       netCashFlow: 911.87,
    //       totalBusinessExpenses: null,
    //     },
    //   ]
    // }
  }
}
